export default __webpack_public_path__ + "static/media/beforeOff.068e51cf.svg";